import { ChangeDetectionStrategy, Component, InputSignal, OutputEmitterRef, input, output } from '@angular/core';
import { MatCard } from '@angular/material/card';

import { DatePipesModule, UtilPipesModule } from '@core/shared/util';

import { CatalogData } from '../../models';

import { CatalogCardFooterComponent } from './catalog-card-footer/catalog-card-footer.component';
import { CatalogParamComponent } from './catalog-param/catalog-param.component';

@Component({
  selector: 'mp-catalog-card',
  templateUrl: './catalog-card.component.html',
  styleUrl: './catalog-card.component.scss',
  imports: [MatCard, UtilPipesModule, DatePipesModule, CatalogCardFooterComponent, CatalogParamComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CatalogCardComponent {
  readonly catalog: InputSignal<CatalogData> = input.required<CatalogData>();

  readonly showAdditionalInfo: InputSignal<boolean> = input<boolean>(true);

  readonly isCatalogNotAssigned: InputSignal<boolean> = input<boolean>(false);
  readonly isCatalogActive: InputSignal<boolean> = input<boolean>(false);

  readonly openTaskIconMap: InputSignal<Record<string, string>> = input<Record<string, string>>({});

  readonly catalogDetailsClick: OutputEmitterRef<string> = output<string>();
}
